import { Entity } from './entities.model';
import { League } from './leagues.model';
import { Club } from './clubs.model';
import { Athlete } from './athletes.model';
import { Referee } from './referee.model';
import { Contributor } from '../features/contributor/models/contributor.model';
import { TablePattern } from './table-patterns';
import { Indexable } from '../core/models/indexable';
import { Relation } from './relations.model';
import { LegalTerm, LegalTermResponse } from '../core/models/legal_term.model';
import { CovidExam } from '../features/covid/models/survey_covid.model';

// tslint:disable: variable-name

export interface PermissionPermissions {
  owner?: boolean;
  legal_responsible?: boolean;
  operations?: {
    [index: string]: boolean
  };
  groups?: {
    [index: string]: boolean
  };
  [index: string]: boolean | any;
}

export class Permission extends TablePattern {
  user_id: number;
  target_id: number;
  target?: Entity;
  permissions: PermissionPermissions;
  user?: User;
}


export type UserType = 'R' | 'A' | 'I';
export const USER_TYPES: Indexable<UserType, string> = {
  A: 'Administrador',
  I: 'Colaborador Interno',
  R: 'Usuário normal'
};

export class User extends Entity {
  /*Admin (4bp) or Regular (Normal user)*/
  name: string;
  document: string;
  country: string;
  nickname: string;
  email: string;
  photo_url: string;
  is_company: boolean;
  user_type: UserType;
  gender: 'M' | 'F';
  rg: string;
  nationality: string;
  place_of_birth: string;
  father_name: string;
  mother_name: string;
  permissions?: UserEntities;
  roles?: Permission[];
  internal_role?: Permission;
  block_reason?: string;
  privacy_accepted?: number;
  validator: boolean;
  contact_phone: string;
  mobile_phone: string;

  // virtual fields
  city_name?: string;

  changed_terms?: LegalTerm[];

  constructor(o: Partial<User>) {
    super(o);
  }
}

export type UserDetail = 'profile' | 'permissions' | 'internal_role' | 'last_covid_exams' | 'responsible_for' | 'last_accepted_terms';

export class UserDetails {
  profile: User;
  permissions: Permission[];
  entities: Entity[];
  internal_role: Permission;
  last_covid_exams: CovidExam[];
  responsible_for: Relation[];
  last_accepted_terms: LegalTermResponse;
}

export class LoggedUser extends User {
  responsible_for: Relation[];
  exclusion_requested: UserExclusionRequest[];
}

export class UserEntities {
  leagues: League[];
  clubs: Club[];
  athletes: Athlete[];
  referees: Referee[];
  contributors: Contributor[];
  users: User[];
}

export type UserExclusionStatus = 'R' | 'A' | 'C' | 'F';

export const USER_EXCLUSION_STATUS: Indexable<UserExclusionStatus, string> = {
  R: 'Aguardando Análise',
  A: 'Em Análise',
  C: 'Cancelado',
  F: 'Finalizado'
};

export interface UserExclusionRequest extends TablePattern {
  user_id: number;
  contact_phone: string;
  protocol: string;
  status: UserExclusionStatus;
}
